import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const heroImageClasses = tv({
	slots: {
		base: 'px-2 md:px-4 2xl:max-w-[172rem] 2xl:mx-auto',
		container: 'mt-2 md:mt-3 grid grid-cols-4 md:grid-cols-6 gap-x-2 lg:gap-x-4',
		imageContainer:
			'md:aspect-[136/54] col-span-4 md:col-span-6 mt-3 md:mt-4 rounded-l overflow-hidden',
		image: 'w-full h-full object-cover',
	},
})

export type HeroImageVariants = VariantProps<typeof heroImageClasses>
